// extracted by mini-css-extract-plugin
export default {"cardbody":"Partners_cardbody__-TlT4","cardimg":"Partners_cardimg__jrnvv"};